import React, { useEffect } from 'react';
import { Box, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import { RadioButtonUncheckedOutlined, RadioButtonCheckedOutlined } from '@mui/icons-material';

interface GoogleDriveAccountFormProps {
  connectionDetails: string;
  refreshRequired: boolean;
  handleUpdateNewGameData: any;
  disabled?: boolean;
  onValidityChange?: (isValid: boolean) => void;
}

const GoogleDriveAccountForm: React.FC<GoogleDriveAccountFormProps> = ({
  connectionDetails,
  refreshRequired,
  handleUpdateNewGameData,
  disabled = false,
  onValidityChange,
}) => {
  const fieldValues = JSON.parse(connectionDetails || '{}');

  useEffect(() => {
    if (
      fieldValues?.iapFileDriveLink &&
      fieldValues?.iaaFileDriveLink &&
      fieldValues?.uaSpendFileDriveLink
    ) {
      onValidityChange?.(true);
    } else {
      onValidityChange?.(false);
    }
  }, [fieldValues]);

  return (
    <>
      <TextField
        label="IAP File Drive Link"
        placeholder="Paste Cloud Storage link here"
        sx={{
          width: '100%',
        }}
        value={fieldValues.iapFileDriveLink}
        onChange={(e) =>
          handleUpdateNewGameData(
            'connectionDetails',
            JSON.stringify({
              ...fieldValues,
              iapFileDriveLink: e.target.value,
            }),
          )
        }
        disabled={disabled}
      />
      <TextField
        label="IAA File Drive Link"
        placeholder="Paste Cloud Storage link here"
        sx={{
          width: '100%',
        }}
        value={fieldValues.iaaFileDriveLink}
        onChange={(e) =>
          handleUpdateNewGameData(
            'connectionDetails',
            JSON.stringify({
              ...fieldValues,
              iaaFileDriveLink: e.target.value,
            }),
          )
        }
        disabled={disabled}
      />
      <TextField
        label="UA Spend File Drive Link"
        placeholder="Paste Cloud Storage link here"
        sx={{
          width: '100%',
        }}
        value={fieldValues.uaSpendFileDriveLink}
        onChange={(e) =>
          handleUpdateNewGameData(
            'connectionDetails',
            JSON.stringify({
              ...fieldValues,
              uaSpendFileDriveLink: e.target.value,
            }),
          )
        }
        disabled={disabled}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography fontSize="0.85rem" fontWeight={700} sx={{ color: '#162936' }}>
          Monthly Refresh
        </Typography>
        <Box sx={{ display: 'flex', gap: '1rem' }}>
          {['Yes', 'No'].map((label, i) => {
            const value = i === 0;
            return (
              <FormControlLabel
                key={label}
                sx={{
                  width: 'fit-content',
                  borderRadius: '0.5rem',
                  mx: 0,
                  '& .MuiFormControlLabel-label': {
                    fontFamily: 'Manrope, sans-serif',
                    fontSize: '0.875rem',
                    fontWeight: 700,
                    color: '#162936',
                  },
                }}
                label={label}
                control={
                  <Checkbox
                    checked={refreshRequired === value}
                    onChange={() => handleUpdateNewGameData('refreshRequired', value)}
                    icon={<RadioButtonUncheckedOutlined />}
                    checkedIcon={<RadioButtonCheckedOutlined />}
                    disabled={disabled}
                  />
                }
              />
            );
          })}
        </Box>
      </Box>
    </>
  );
};

export default GoogleDriveAccountForm;
